import styled from '@marvelapp/styled';
import { inputStyles } from '../Input/styles';
export const TextareaElement = styled.textarea `
  ${inputStyles};
  ${(props) => !props.showBorder && `border: none;`};
`;
